import React, { useState } from "react";
import { createPlayerListing, updatePlayerListing } from "../lib/playerListings";
import { uploadPlayerListingPhoto } from "../lib/storage";
import { T } from "../theme";
import { Btn, CONDITIONS, Input, PhotoPicker, SectionTitle, Select } from "../ui";

const POWER_STATUSES = ["Tested — Works", "Untested", "For Parts / Repair"];

export default function CreatePlayerListingScreen({ ownerUserId, onDone, onCancel }) {
  const [brand, setBrand] = useState("");
  const [model, setModel] = useState("");
  const [era, setEra] = useState("");
  const [condition, setCondition] = useState("Unknown");
  const [powerStatus, setPowerStatus] = useState(POWER_STATUSES[0]);
  const [price, setPrice] = useState("");
  const [description, setDescription] = useState("");
  const [photos, setPhotos] = useState([]);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  const save = async () => {
    setError("");
    if (!brand || !model) {
      setError("Brand and model are required.");
      return;
    }
    if (price === "") {
      setError("Enter a price.");
      return;
    }
    if (!description.trim()) {
      setError("Add a description with how buyers should contact you.");
      return;
    }
    setSaving(true);
    try {
      const docRef = await createPlayerListing(ownerUserId, {
        brand,
        model,
        era: era || null,
        condition,
        powerStatus,
        price: Number(price),
        currencyCode: "USD",
        description: description.trim(),
        photoUrls: [],
      });
      if (photos.length > 0) {
        const photoUrls = await Promise.all(photos.map((p) => uploadPlayerListingPhoto(ownerUserId, docRef.id, p.file)));
        await updatePlayerListing(docRef.id, { photoUrls });
      }
      onDone();
    } catch (e) {
      setError("Could not create this listing. Please try again.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div>
      <PhotoPicker items={photos} onChange={setPhotos} max={5} />

      <SectionTitle>Player Details</SectionTitle>
      <Input label="Brand *" value={brand} onChange={(e) => setBrand(e.target.value)} placeholder="e.g. Panasonic, Craig, GE" />
      <Input label="Model *" value={model} onChange={(e) => setModel(e.target.value)} placeholder="e.g. RQ-830S" />
      <Input label="Era / Year" value={era} onChange={(e) => setEra(e.target.value)} placeholder="e.g. early 1970s" />
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
        <Select label="Condition" value={condition} onChange={(e) => setCondition(e.target.value)} options={CONDITIONS} />
        <Select label="Power Status" value={powerStatus} onChange={(e) => setPowerStatus(e.target.value)} options={POWER_STATUSES} />
      </div>
      <Input label="Price ($)" value={price} onChange={(e) => setPrice(e.target.value)} placeholder="0.00" type="number" />

      {error && <div style={{ color: "#C0392B", fontSize: 12, marginBottom: 10 }}>{error}</div>}

      <SectionTitle>Description &amp; Contact Info</SectionTitle>
      <div style={{ marginBottom: 10 }}>
        <textarea value={description} onChange={(e) => setDescription(e.target.value)} placeholder="Describe the player's condition and how buyers can reach you — there's no in-app messaging yet." style={{ width: "100%", background: T.inputBg, border: `1px solid ${T.border}`, borderRadius: 6, color: T.text, padding: "9px 11px", fontSize: 13, fontFamily: T.font, outline: "none", boxSizing: "border-box", minHeight: 90, resize: "vertical" }} />
      </div>

      <div style={{ display: "flex", gap: 10, marginTop: 6 }}>
        <Btn variant="outline" onClick={onCancel} style={{ flex: 1 }}>Cancel</Btn>
        <Btn disabled={saving} onClick={save} style={{ flex: 2 }}>{saving ? "Posting…" : "Post Listing"}</Btn>
      </div>
      <div style={{ height: 20 }} />
    </div>
  );
}
